"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var icon_1 = require("../../constants/img/icon");
var IconTextBtn_1 = require("../common/Btn/IconTextBtn");
var MenuBtn = function (_a) {
    var closeMenu = _a.closeMenu;
    return ((0, preact_1.h)(IconTextBtn_1.default, { onClick: closeMenu, img: icon_1.MENU_BAR, alt: '', text: 'menu', childClass: 'menu' }));
};
exports.default = MenuBtn;
